module.exports = __webpack_public_path__ + "static/img/cat-white.b0bb0f54.svg";